export default __webpack_public_path__ + "static/hero_alpha-de05d92d348230bfe2fb7cf408dbe241.png";